/* =============================================================================
   Akademija Starfy - Messierjev katalog za prvo leto
   =============================================================================
   Trideset objektov, urejenih po tezavnosti.

   Zakaj tezavnost ni magnituda:

     M31 ima sij 3,4 - svetlejsi od vecine zvezd. M57 ima 8,8, kar zveni
     stokrat sibkeje. V resnici je M57 lazji, ker je njegova svetloba stisnjena
     na eno kotno minuto, M31 pa razmazana cez podrocje, siroko sest polnih Lun.

     Pravi merilo je POVRSINSKI SIJ: koliko svetlobe pade na kvadratno kotno
     minuto. Racunamo ga kot

         SB = m + 2,5 log10(A)        A = ploscina v kvadratnih kotnih minutah

     in ga izpisemo ob vsakem objektu, ker je to stevilka, ki pojasni, zakaj
     je nekaj tezje, kot pise na skatli.

   Tezavnostna ocena od 1 do 5 pa NI izracunana. Je ocena iz opazovalne
   izkusnje, ker noben obrazec ne zajame tega, da ima M31 svetlo jedro in
   bledo obrobje, ali da je M13 lep ze pri 80 mm in osupljiv pri 250 mm.
   Formula bi bila videti bolj znanstveno in bi bila slabsa.
   ========================================================================== */
(function () {
  "use strict";

  /* t = tezavnost 1-5, mag = celotni sij, a x b = velikost v kotnih minutah,
     sezona = kdaj je zvecer najvisje */
  var M = [
    { id: "M45", ime: "Gostosevci", tip: "odprta kopica", mag: 1.6, a: 110, b: 110, t: 1, sez: "zima",
      kaj: "Šest do devet zvezd s prostim očesom, v daljnogledu polje modrih draguljev." },
    { id: "M42", ime: "Orionova meglica", tip: "meglica", mag: 4.0, a: 85, b: 60, t: 1, sez: "zima",
      kaj: "Edina meglica, ki v majhnem teleskopu takoj prepriča. Siva krila in Trapez v sredini." },
    { id: "M31", ime: "Andromedina galaksija", tip: "galaksija", mag: 3.4, a: 178, b: 63, t: 1, sez: "jesen",
      kaj: "Svetlo jedro najdete povsod, bledo obrobje samo pod temnim nebom." },
    { id: "M44", ime: "Jasli", tip: "odprta kopica", mag: 3.7, a: 95, b: 95, t: 1, sez: "pomlad",
      kaj: "Preveč razsuta za teleskop, popolna za daljnogled." },
    { id: "M13", ime: "Kopica v Herkulu", tip: "kroglasta kopica", mag: 5.8, a: 20, b: 20, t: 2, sez: "poletje",
      kaj: "Pri 80 mm meglena krogla, pri 200 mm zrnata do jedra. Objekt, ki najbolj nagradi premer." },
    { id: "M57", ime: "Prstanasta meglica", tip: "planetarna meglica", mag: 8.8, a: 1.4, b: 1.0, t: 2, sez: "poletje",
      kaj: "Majhen dimni obroček. Sij zveni šibek, a je stisnjen na drobno ploskev - zato je lahek." },
    { id: "M27", ime: "Meglica Ročka", tip: "planetarna meglica", mag: 7.4, a: 8.0, b: 5.6, t: 2, sez: "poletje",
      kaj: "Ogrizek jabolka. Ena redkih meglic, ki prenese mestno nebo." },
    { id: "M15", ime: "Kopica v Pegazu", tip: "kroglasta kopica", mag: 6.2, a: 18, b: 18, t: 2, sez: "jesen",
      kaj: "Gostejša od M13, jedra tudi veliki teleskopi ne razkrojijo." },
    { id: "M35", ime: "Kopica v Dvojčkih", tip: "odprta kopica", mag: 5.1, a: 28, b: 28, t: 2, sez: "zima",
      kaj: "Stotine zvezd pri majhni povečavi. Dober test ostrine." },
    { id: "M36", ime: "Kopica v Vozniku", tip: "odprta kopica", mag: 6.3, a: 12, b: 12, t: 2, sez: "zima",
      kaj: "Ena od treh kopic Voznika; tri v eni noči so lep večer za začetnika." },
    { id: "M37", ime: "Bogata kopica Voznika", tip: "odprta kopica", mag: 6.2, a: 24, b: 24, t: 2, sez: "zima",
      kaj: "Najbogatejša od treh, z rdečkasto zvezdo v sredini." },
    { id: "M3", ime: "Kroglasta kopica v Lovskih psih", tip: "kroglasta kopica", mag: 6.2, a: 18, b: 18, t: 2, sez: "pomlad",
      kaj: "Prva velika kroglasta kopica pomladi, skoraj enakovredna M13." },
    { id: "M81", ime: "Bodejeva galaksija", tip: "galaksija", mag: 6.9, a: 27, b: 14, t: 3, sez: "pomlad",
      kaj: "Okrogla lisa s svetlim jedrom, v istem polju s cigaro M82." },
    { id: "M82", ime: "Galaksija Cigara", tip: "galaksija", mag: 8.4, a: 11, b: 4.3, t: 3, sez: "pomlad",
      kaj: "Podolgovata proga; pri 200 mm se v njej pokaže temna razpoka." },
    { id: "M5", ime: "Kroglasta kopica v Kači", tip: "kroglasta kopica", mag: 5.6, a: 23, b: 23, t: 2, sez: "poletje",
      kaj: "Mnogi jo imajo za lepšo od M13, le nižje je nad obzorjem." },
    { id: "M11", ime: "Kopica Divje race", tip: "odprta kopica", mag: 6.3, a: 14, b: 14, t: 2, sez: "poletje",
      kaj: "Tako gosta, da je videti kot kroglasta. Klinasta oblika, po kateri ima ime." },
    { id: "M92", ime: "Druga kopica Herkula", tip: "kroglasta kopica", mag: 6.4, a: 14, b: 14, t: 3, sez: "poletje",
      kaj: "Manjša soseda M13, ki jo večina spregleda. Zaslužila bi si več." },
    { id: "M8", ime: "Laguna", tip: "meglica", mag: 6.0, a: 90, b: 40, t: 3, sez: "poletje",
      kaj: "Velika in svetla, a nizko nad obzorjem - iz Slovenije jo lovite julija okoli polnoči." },
    { id: "M22", ime: "Kopica v Strelcu", tip: "kroglasta kopica", mag: 5.1, a: 32, b: 32, t: 3, sez: "poletje",
      kaj: "Svetlejša od M13, a nizka. Kdor jo ujame visoko, se je spomni." },
    { id: "M51", ime: "Vrtinčasta galaksija", tip: "galaksija", mag: 8.4, a: 11, b: 7, t: 4, sez: "pomlad",
      kaj: "Dve megličasti lisi; krake zaslutite šele pri 200 mm in temnem nebu." },
    { id: "M104", ime: "Sombrero", tip: "galaksija", mag: 8.0, a: 9, b: 4, t: 4, sez: "pomlad",
      kaj: "Podolgovata z zaslutljivo temno progo. Nizko, a vredna truda." },
    { id: "M97", ime: "Meglica Sova", tip: "planetarna meglica", mag: 9.9, a: 3.4, b: 3.3, t: 4, sez: "pomlad",
      kaj: "Bleda okrogla ploskev; dve temni očesi šele pri 250 mm." },
    { id: "M1", ime: "Rakovica", tip: "ostanek supernove", mag: 8.4, a: 6, b: 4, t: 4, sez: "zima",
      kaj: "Siva podolgovata packa. Slavna zaradi zgodovine, ne zaradi videza skozi okular." },
    { id: "M33", ime: "Galaksija v Trikotniku", tip: "galaksija", mag: 5.7, a: 73, b: 45, t: 5, sez: "jesen",
      kaj: "Sij pravi, da je lahka, površinski sij pravi nasprotno. Pod mestnim nebom je praktično nevidna." },
    { id: "M101", ime: "Vetrnica", tip: "galaksija", mag: 7.9, a: 29, b: 27, t: 5, sez: "pomlad",
      kaj: "Svetloba razmazana čez ogromno ploskev. Najbolj varljiv objekt na tem seznamu." },
    { id: "M76", ime: "Mala ročka", tip: "planetarna meglica", mag: 10.1, a: 2.7, b: 1.8, t: 5, sez: "jesen",
      kaj: "Najšibkejši Messier. Če ga najdete, znate iskati." },
    { id: "M63", ime: "Sončnica", tip: "galaksija", mag: 8.6, a: 12.6, b: 7.2, t: 4, sez: "pomlad",
      kaj: "Gladka ovalna lisa; struktura se pokaže samo na fotografiji." },
    { id: "M64", ime: "Črnooka galaksija", tip: "galaksija", mag: 8.5, a: 9.3, b: 5.4, t: 4, sez: "pomlad",
      kaj: "Temna prašna lisa ob jedru je vidna že pri 150 mm - redka poslastica." },
    { id: "M65", ime: "Trojka v Levu (M65)", tip: "galaksija", mag: 9.3, a: 8.7, b: 2.5, t: 4, sez: "pomlad",
      kaj: "Ena od treh galaksij v enem polju. Tri galaksije naenkrat so mejnik." },
    { id: "M2", ime: "Kroglasta kopica v Vodnarju", tip: "kroglasta kopica", mag: 6.5, a: 16, b: 16, t: 3, sez: "jesen",
      kaj: "Zbita in simetrična; jesenska zamenjava za M13." }
  ];


  /* Slika s pripisom. Oznaka "fotografija" ni okras: obe poglavji ucita, da
     skozi okular tega NE boste videli tako, in glosna slika brez te oznake bi
     to lekcijo tiho izpodbila. */
  function slikaHtml(kljuc) {
    var s = (window.STARFY_SLIKE || {})[String(kljuc).toUpperCase()];
    if (!s) return "";
    var lic = s.lu ? '<a href="' + s.lu + '" rel="nofollow noopener" target="_blank">' + s.l + "</a>" : s.l;
    return '<span class="ak-foto">' +
      '<img src="' + s.u + '" alt="" loading="lazy" decoding="async">' +
      '<span class="ak-foto-cap"><b>fotografija</b>, ne pogled skozi okular · ' +
      '<a href="' + s.v + '" rel="nofollow noopener" target="_blank">' + s.a + "</a> · " + lic +
      "</span></span>";
  }

  var host = document.querySelector("[data-ak-messier]");
  if (!host) return;

  var inAper = host.querySelector("[data-in-aper]");
  var outAper = host.querySelector("[data-out-aper]");
  var skyBtns = host.querySelectorAll("[data-sky]");
  var modeBtns = host.querySelectorAll("[data-mode]");
  var inF = host.querySelector("[data-in-f]");
  var inMin = host.querySelector("[data-in-min]");
  var outF = host.querySelector("[data-out-f]");
  var outMin = host.querySelector("[data-out-min]");
  var boxVid = host.querySelector("[data-box-vizualno]");
  var boxFoto = host.querySelector("[data-box-foto]");
  var oprema = host.querySelector("[data-out-oprema]");
  var mode = "vizualno";
  var list = host.querySelector("[data-out-list]");
  var summary = host.querySelector("[data-out-summary]");
  var sky = "primestje";

  /* Povrsinski sij: sij, razmazan cez ploscino. Nizja stevilka je svetlejse. */
  function surfaceBrightness(o) {
    var area = Math.PI * (o.a / 2) * (o.b / 2);
    return o.mag + 2.5 * Math.log10(area);
  }

  /* ---------------------------------------------------------------------
     VIZUALNO in FOTOGRAFSKO nista ista naloga
     ---------------------------------------------------------------------
     Prva razlicica te strani je govorila samo o premeru - kar velja za oko,
     ne pa za kamero, in tega ni nikjer pisalo. Napaka je bila v tem, da je
     bila trditev videti splosna, veljala pa je le za en nacin opazovanja.

     Oko svetlobe NE kopici: kar ne vidi v desetinki sekunde, ne vidi nikoli,
     zato pri njem odloca premer. Kamera jo kopici: signal raste s casom,
     sum pa le s korenom casa, zato se razmerje izboljsuje, dokler zbiras.

     Zato pri fotografiji premer skoraj ne steje. Stejeta:

       GORISCNO RAZMERJE - kolicina svetlobe na piksel na sekundo pada s
       kvadratom stevila f. Teleskop f/5 nabira stirikrat hitreje od f/10,
       ne glede na premer.

       SKUPNI CAS ZBIRANJA - stiri ure kratkih posnetkov gredo globlje kot
       ena ura, ceprav je teleskop isti.

     Posledica, ki zacetnike najbolj preseneti: majhen teleskop f/5 s kamero
     na sledeci montazi posname M33 bolje, kot ga velik Dobson pokaze ocesu.
     --------------------------------------------------------------------- */
  function reachFoto(fRatio, minute, skyKey) {
    var skyPts = skyKey === "mesto" ? -1.5 : (skyKey === "temno" ? 1.5 : 0);
    // Izhodisce je f/5 in ena ura; od tam naprej cas navzgor, stevilo f navzdol.
    var cas = 2.5 * Math.log10(Math.max(5, minute) / 60);
    var svetlost = -5 * Math.log10(Math.max(2, fRatio) / 5);
    // Najsvetlejsi objekti se posnamejo v nekaj sekundah pod vsakim nebom -
    // spodnja meja pove resnico, ki bi jo obrazec sicer zatajil.
    return Math.max(1, 4.0 + cas + svetlost + skyPts);
  }

  /* Do katere tezavnosti seze ta oprema pod tem nebom - VIZUALNO.
     Premer prispeva logaritemsko, ker tako prispeva tudi svetloba. */
  function reach(aper, skyKey) {
    var apPts = 5 * Math.log10(Math.max(30, aper) / 50) * 0.95;
    var skyPts = skyKey === "mesto" ? -1.5 : (skyKey === "temno" ? 1.5 : 0);
    // Izhodisce 2,9 in ne 2,4: pri 2,4 je 50 mm pod mestnim nebom dalo NIC,
    // kar ni res - Orion in Gostosevci se vidita tudi iz mesta. Konstanta je
    // umerjena po opazovalni izkusnji, ne izpeljana; to je posteno povedati.
    return 2.9 + apPts + skyPts;
  }

  function draw() {
    var aper = +inAper.value, f = +inF.value / 10, minute = +inMin.value;
    outAper.textContent = aper + " mm";
    outF.textContent = "f/" + f.toFixed(1).replace(".", ",").replace(",0", "");
    outMin.textContent = minute < 60 ? minute + " min"
      : (minute / 60).toFixed(1).replace(".", ",").replace(",0", "") + " h";

    var foto = mode === "foto";
    boxVid.hidden = foto;
    boxFoto.hidden = !foto;
    var r = foto ? reachFoto(f, minute, sky) : reach(aper, sky);

    var ok = M.filter(function (o) { return o.t <= r; });
    var meja = M.filter(function (o) { return o.t > r && o.t <= r + 1; });
    var nebo = { mesto: "mestnim nebom", primestje: "primestnim nebom", temno: "temnim nebom" }[sky];

    summary.textContent = foto
      ? "Pri " + outF.textContent + " in " + outMin.textContent + " skupnega zbiranja pod " + nebo +
        " je posnetih " + ok.length + " od " + M.length + " objektov" + (meja.length ? ", " + meja.length + " pa na meji." : ".")
      : "S premerom " + aper + " mm pod " + nebo +
        " je udobno dosegljivih " + ok.length + " od " + M.length + " objektov" + (meja.length ? ", " + meja.length + " pa na meji." : ".");

    // Fotografija ni samo drugacen izracun - je drugacna oprema, in to je
    // posteno povedati na istem mestu, kjer obljubljamo rezultat.
    oprema.hidden = !foto;

    var sorted = M.slice().sort(function (x, y) { return x.t - y.t || x.mag - y.mag; });
    list.innerHTML = sorted.map(function (o) {
      var sb = surfaceBrightness(o);
      var dosegljiv = o.t <= r;
      var naMeji = !dosegljiv && o.t <= r + 1;
      return '<li class="ak-obj' + (dosegljiv ? " is-ok" : (naMeji ? " is-edge" : "")) + '">' +
        '<span class="ak-obj-alt">' + o.id + "</span>" +
        slikaHtml(o.id) +
        '<span class="ak-obj-body"><b>' + o.ime + "</b>" +
        '<em>' + o.kaj + "</em>" +
        '<span class="ak-obj-meta">' + o.tip + " · " + o.sez +
        " · sij " + String(o.mag).replace(".", ",") +
        " · površinski sij " + sb.toFixed(1).replace(".", ",") +
        " · težavnost " + o.t + "/5</span></span>" +
        '<span class="ak-obj-flag">' +
          (dosegljiv ? (foto ? "posneto" : "dosegljivo") : (naMeji ? "na meji" : (foto ? "potrebuje več časa" : "potrebuje več"))) +
        "</span></li>";
    }).join("");
  }

  skyBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      sky = b.getAttribute("data-sky");
      skyBtns.forEach(function (x) { x.classList.toggle("is-on", x === b); });
      draw();
    });
  });
  modeBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      mode = b.getAttribute("data-mode");
      modeBtns.forEach(function (x) { x.classList.toggle("is-on", x === b); });
      draw();
    });
  });
  [inAper, inF, inMin].forEach(function (i) { i.addEventListener("input", draw); });
  draw();
})();
